module.exports = __webpack_public_path__ + "static/media/shell32_26.b0b7a6c5.ico";